import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type EngagementNoteOut = components['schemas']['EngagementNoteOut'];
export type EngagementNoteListOut = components['schemas']['EngagementNoteListOut'];

/** Practitioner read of an engagement's notes stream, newest first. */
export function listEngagementNotes(
  engagementId: string,
  idToken: string,
): Promise<EngagementNoteListOut> {
  return apiClient
    .GET('/api/engagements/{engagement_id}/notes', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<EngagementNoteListOut>);
}
